import mixpanel from 'mixpanel-browser'
import { AnalyticsTrackerBase, AnalyticsAttributeTypes } from './index'

const MIX_PANEL_DEBUG_KEY: string = 'e2e2f6fcbc7c140ee89d385cd3edfaea'
const MIX_PANEL_RELEASE_KEY: string = '2d2cb3e4d2a9edcf9d907af9f1afe412'

export default class MixpanelAnalyticsTracker extends AnalyticsTrackerBase {
  trackingEnabled: boolean

  constructor(mode: string) {
    if (mode === 'release') {
      mixpanel.init(MIX_PANEL_RELEASE_KEY)
    } else if (mode === 'debug') {
      mixpanel.init(MIX_PANEL_DEBUG_KEY)
    } else {
      mixpanel.init('No Token')
    }
    super()
    this.trackingEnabled = true
  }

  async initializeIfNeeded() {
    this.trackingEnabled = true // we can change based on consent later
  }

  async identify(id: string) {
    await mixpanel.identify(id)
  }

  async updateProperties(key: string, value: string) {
    await mixpanel.register({ [key]: value })
  }

  track(event: string, extras?: { [key: string]: AnalyticsAttributeTypes }) {
    console.debug(
      `[Mixpanel] enabled=${
        this.trackingEnabled
      } event=${event} properties=${JSON.stringify(extras)}`
    )
    mixpanel.track(event, {
      ...extras,
    })
  }
}
